/**
 * The language toggle.
 *
 * A segmented pair rather than a dropdown: there are exactly two locales, the
 * choice is one an operator makes once, and each option is written in its own
 * language so it is legible to someone who cannot read the other one.
 *
 * The selection is persisted to `localStorage` by the provider, so it survives
 * a reload but stays on this device — it is a reading preference, not workspace
 * configuration, and the app is explicit elsewhere that workspace configuration
 * lives server-side.
 */

import { LOCALES, useLocale, useT } from '../../i18n';
import { en } from '../../i18n/en';
import { ko } from '../../i18n/ko';

const LOCALE_NAMES = { en: en.meta.localeName, ko: ko.meta.localeName };

export function LanguageToggle() {
  const t = useT();
  const { locale, setLocale } = useLocale();

  return (
    <div className="lang-toggle" role="group" aria-label={t.shell.languageLabel}>
      {LOCALES.map((option) => (
        <button
          key={option}
          type="button"
          className={
            option === locale ? 'btn btn--sm btn--primary' : 'btn btn--sm btn--subtle'
          }
          aria-pressed={option === locale}
          lang={option}
          onClick={() => setLocale(option)}
        >
          {LOCALE_NAMES[option]}
        </button>
      ))}
    </div>
  );
}
